export default __webpack_public_path__ + "static/media/loginLogo.c53e3a28.png";